import { render, staticRenderFns } from "./oomSlider.vue?vue&type=template&id=4ee924ee&scoped=true"
import script from "./oomSlider.vue?vue&type=script&lang=js"
export * from "./oomSlider.vue?vue&type=script&lang=js"
import style0 from "./oomSlider.vue?vue&type=style&index=0&id=4ee924ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee924ee",
  null
  
)

export default component.exports